/**
 * Markdown parser. Returns metadata and content of a markdown string.
 * @module helpers/markdown/parser
 * @param {string} markdown
 * @returns {{metadata: Object, content: string}}
 */
export const parseMarkdownPage = markdown => {
  const metadataRegex = /^---\n([\s\S]*?)\n---\n/;
  // const parts = markdown.match(metadataRegex);
  const metadataMatch = markdown.match(metadataRegex);

  if (!metadataMatch) {
    return { metadata: {}, content: markdown };
  }
  const metadata = metadataMatch[1].split('\n').reduce((acc, line) => {
    const [key, value] = line.split(': ');

    return { ...acc, [key]: value };
  }, {});
  const content = markdown.replace(metadataRegex, '');

  return { metadata, content };
  // const metadata = parts.split('\n').reduce((acc, line) => {
  //   const [key, value] = line.split(': ');

  //   return { ...acc, [key]: value };
  // }, {});
  // const content = markdown.replace(metadataRegex, '');

  // return { metadata, content };

  // const content = split.slice(1).join('\n---\n');

  // return { metadata, content };
};

/**
 * Parse markdown string into html
 * @param {string} markdown
 * @returns {string}
 */
export const parseMarkdown = markdown => {
  if (!markdown || typeof markdown !== 'string') {
    return '';
  }
  const lines = markdown.split('\n');
  const stack = []; // Stack to track open lists
  let html = '';

  const closeLists = level => {
    while (stack.length > level) {
      const tag = stack.pop();
      html += `</${tag}>`;
    }
  };

  lines.forEach(line => {
    // Handle headings
    if (/^### (.*$)/.test(line)) {
      closeLists(0);
      html += `<h3>${line.match(/^### (.*$)/)[1]}</h3>`;
    } else if (/^## (.*$)/.test(line)) {
      closeLists(0);
      html += `<h2>${line.match(/^## (.*$)/)[1]}</h2>`;
    } else if (/^# (.*$)/.test(line)) {
      closeLists(0);
      html += `<h1>${line.match(/^# (.*$)/)[1]}</h1>`;
    }
    // Handle blockquotes
    else if (/^\> (.*$)/.test(line)) {
      closeLists(0);
      html += `<blockquote>${line.match(/^\> (.*$)/)[1]}</blockquote>`;
    }

    // Handle list items
    else if (/^( *)(\*|\d\.)[ \t](.*)$/.test(line)) {
      const match = line.match(/^( *)(\*|\d\.)[ \t](.*)$/);
      const spaces = match[1].length;
      const marker = match[2];
      const content = match[3];
      const level = spaces / 2; // Assume 2 spaces per nesting level
      const tag = marker === '*' ? 'ul' : 'ol';
      const className = marker === '*' ? 'list-disc' : 'list-decimal';

      if (stack.length < level + 1) {
        // Open a new list
        stack.push(tag);
        html += `<${tag} class="pl-8 ${className}">`;
      } else if (stack.length > level + 1) {
        // Close lists to match the current level
        closeLists(level + 1);
      }

      // Add the list item
      html += `<li>${content}</li>`;
    }
    // Handle paragraphs
    else if (line.trim()) {
      closeLists(0);
      // Replace inline markdown with html
      const lineHtml = line
        .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>') // bold text
        .replace(/\*(.*)\*/gim, '<i>$1</i>') // italic text
        .replace(/!\[(.*?)\]\((.*?)\)/gim, '<img alt="$1" src="$2" />') // images
        .replace(/\[(.*?)\]\((.*?)\)/gim, '<a href="$2">$1</a>') // links
        .trim();
      html += `<p class="mb-4">${lineHtml}</p>`;
      // html += `<span class="">${lineHtml}</span>`;
    }

    // // Handle links
    // else if (/\[(.*?)\]\((.*?)\)/.test(line)) {
    //   // closeLists(0);
    //   const match = line.match(/\[(.*?)\]\((.*?)\)/);
    //   html += `<a href="${match[2]}">${match[1]}</a>`;
    // }
    // // Handle bold text
    // else if (/\*\*(.*)\*\*/.test(line)) {
    //   // closeLists(0);
    //   const match = line.match(/\*\*(.*)\*\*/);
    //   html += `<b>${match[1]}</b>`;
    // }
    // // Handle italic text
    // else if (/\*(.*)\*/.test(line)) {
    //   // closeLists(0);
    //   const match = line.match(/\*(.*)\*/);
    //   html += `<i>${match[1]}</i>`;
    // }
    // // Handle images
    // else if (/!\[(.*?)\]\((.*?)\)/.test(line)) {
    //   // closeLists(0);
    //   const match = line.match(/!\[(.*?)\]\((.*?)\)/);
    //   html += `<img alt="${match[1]}" src="${match[2]}" />`;
    // }
  });

  // Close any remaining open lists
  closeLists(0);

  return html.trim();
};

export const parseMarkdown2 = markdown => {
  const html = (markdown || '')
    // Replace greater and less then signs
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/^### (.*$)/gim, '<h3>$1</h3>') // h3 tag
    .replace(/^## (.*$)/gim, '<h2>$1</h2>') // h2 tag
    .replace(/^# (.*$)/gim, '<h1>$1</h1>') // h1 tag
    .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>') // bold text
    .replace(/\*(.*)\*/gim, '<i>$1</i>') // italic text
    .replace(/!\[(.*?)\]\((.*?)\)/gim, '<img alt="$1" src="$2" />') // images
    .replace(/\[(.*?)\]\((.*?)\)/gim, '<a href="$2">$1</a>') // links
    .replace(/^\> (.*$)/gim, '<blockquote>$1</blockquote>') // blockquotes
    // Wrap all lines that start with a * in a <ul>
    // --- with hr
    .replace(/^\s*\n\*/gim, '<ul class="list-disc list-inside">\n*') // ul lists
    .replace(/^(\*.+)\s*\n([^\*])/gim, '$1\n</ul>\n\n$2') // ul lists

    .replace(/^\* (.*$)/gim, '<li>$1</li>') // ul lists
    .replace(/^\s*\n\d\./gim, '<ol class="list-decimal list-inside">\n1.') // ol lists
    .replace(/^\d\. (.*$)/gim, '<li>$1</li>') // lists
    .replace(/^(\d\..+)\s*\n([^\d\.])/gim, '$1\n</ol>\n\n$2') // ol lists

    .replace(/^\* (.*$)/gim, '<li>$1</li>') // lists
    .replace(/^\d\. (.*$)/gim, '<li>$1</li>') // lists

    // .replace(/^(?!<h|<b|<i|<ul|<ol|<li|<img|<a|<br|\n)(.*$)/gim, '<p class="mb-4">$1</p>');
    .replace(/^(?!<h|<ul|<ol|<li|<img|<a|<br|\n)(.*$)/gim, '<p class="mb-2">$1</p>');
  // .replace(/\n$/gim, '<br />'); // line breaks

  return html.trim(); // using trim method to remove whitespace
};
